import axios from "axios";
import { API } from "@/config/apiBase";

/**
 * Analytics helper for tracking product events
 * Calls POST /api/analytics/events
 * Failures are swallowed to never block UI
 */

// Event name constants (match backend)
export const EventNames = {
  // Billing / Family
  UPGRADE_CLICKED: "upgrade_clicked",
  CANCEL_CLICKED: "cancel_clicked",
  STRIPE_CHECKOUT_STARTED: "stripe_checkout_started",
  
  // AI
  AI_USED: "ai_used",
  
  // Core
  CALL_LOG_SAVED: "call_log_saved",
  CONTACT_CREATED: "contact_created",
};

/**
 * Track a product event
 * @param {string} eventName - Event name from EventNames
 * @param {object} metadata - Additional event data
 * @returns {Promise<void>} - Never throws, swallows errors
 */
export const trackEvent = async (eventName, metadata = {}) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      console.debug("[Analytics] No token, skipping event:", eventName);
      return;
    }

    await axios.post(
      `${API}/analytics/events`,
      { event_name: eventName, metadata },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    
    console.debug("[Analytics] Event tracked:", eventName, metadata);
  } catch (error) {
    // Swallow errors - don't affect UX
    console.debug("[Analytics] Failed to track event:", eventName, error?.message);
  }
};

/**
 * Track upgrade button click
 * @param {string} plan - "plus" or "family"
 * @param {string} source - "pricing", "settings", "banner", "dashboard"
 */
export const trackUpgradeClicked = (plan, source) => {
  trackEvent(EventNames.UPGRADE_CLICKED, { plan, source });
};

/**
 * Track cancel/manage billing click
 * @param {string} source - "settings_billing", "pricing"
 */
export const trackCancelClicked = (source) => {
  trackEvent(EventNames.CANCEL_CLICKED, { source });
};

/**
 * Track Stripe checkout started
 * @param {string} plan - "plus" or "family"
 */
export const trackCheckoutStarted = (plan) => {
  trackEvent(EventNames.STRIPE_CHECKOUT_STARTED, { plan });
};

export default { trackEvent, trackUpgradeClicked, trackCancelClicked, trackCheckoutStarted, EventNames };
